import {Booking} from "@/classes/viewmodels/Booking";

export default class FreightBooking extends Booking {

    constructor() {
        super();

        this.shipment = {

            shipmentRef: '',
            shipmentRefBolNumber: false,
            shipmentShipperRef: '',
            shipmentConsigneeRef: '',
            shipmentCarrier: '',
            shipmentServiceType: '',
            shipmentBillingParty: '',
            shipmentBillingPartyId: '',
            shipmentBillingPartyDetail: '',
            shipmentDescription: '',
            shipmentComments: '',
            shipmentPickupDate: '',
            shipmentDeliveryDate: '',
            shipmentDeliveryTime: '',
            shipmentCurrency: '',
            shipmentValue: '',
            shipmentInsurance: false,
            shipmentInsuranceAmount: '',

        }

        this.tileSelection = {

            shipper: true,
            consignee: false,
            shipment: false,
            dimensions: false,
            documents: false
        }

        this.tileValidation = {

            shipper: true,
            consignee: true,
            shipment: true,
            dimensions: true
        }

        this.metaData = {

            shippers: [],
            consignees: [],
            packageTypes: [],
            serviceTypes: [],
            currencies: [],
            billingParties: [],
            countries: [],
            validatedFields: []

        }

        this.tempValidatedFields = [

            //     new ValidatedField('shipperName', true, true, 'Shipper Name'),
            //     new ValidatedField('shipperAddressLine1', true, false, 'Shipper AddressLine 1'),
            //     new ValidatedField('shipperAddressLine2', true, false, 'Shipper AddressLine 2'),
            //     new ValidatedField('shipperCity', true, false, 'Shipper City'),
            //     new ValidatedField('shipperCounty', true, false, 'Shipper County'),
            //     new ValidatedField('shipperPostcode', true, false, 'Shipper Postcode'),
            //     new ValidatedField('shipperCountry', true, false, 'Shipper Country'),
            //     new ValidatedField('shipperVatNumber', true, false, 'Shipper VAT Number'),
            //     new ValidatedField('shipperContactFullName', true, false, 'Shipper Contact Selection'),
            //     new ValidatedField('shipperContactTitle', true, false, 'Shipper Contact Title'),
            //     new ValidatedField('shipperContactFirstName', true, false, 'Shipper Contact First Name'),
            //     new ValidatedField('shipperContactLastName', true, false, 'Shipper Contact Last Name'),
            //     new ValidatedField('shipperContactPhone', true, false, 'Shipper Contact Telephone'),
            //     new ValidatedField('shipperContactEmail', true, false, 'Shipper Contact Email'),
            //     new ValidatedField('shipperContactDepartment', true, false, 'Shipper Contact Department'),
            //     new ValidatedField('consigneeName', true, false, 'Consignee Name'),
            //     new ValidatedField('consigneeAddressLine1', true, false, 'Consignee AddressLine 1'),
            //     new ValidatedField('consigneeAddressLine2', true, false, 'Consignee AddressLine 2'),
            //     new ValidatedField('consigneeCity', true, false, 'Consignee City'),
            //     new ValidatedField('consigneeCounty', true, false, 'Consignee County'),
            //     new ValidatedField('consigneePostcode', true, false, 'Consignee Postcode'),
            //     new ValidatedField('consigneeCountry', true, false, 'Consignee Country'),
            //     new ValidatedField('consigneeVatNumber', true, false, 'Consignee VAT Number'),
            //     new ValidatedField('consigneeContactFullName', true, false, 'Consignee Contact Selection'),
            //     new ValidatedField('consigneeContactTitle', true, false, 'Consignee Contact Title'),
            //     new ValidatedField('consigneeContactFirstName', true, false, 'Consignee Contact First Name'),
            //     new ValidatedField('consigneeContactLastName', true, false, 'Consignee Contact Last Name'),
            //     new ValidatedField('consigneeContactPhone', true, false, 'Consignee Contact Phone'),
            //     new ValidatedField('consigneeContactEmail', true, false, 'Consignee Contact Email'),
            //     new ValidatedField('shipmentRef', true, false, 'Shipment Reference'),
            //     new ValidatedField('shipmentConsigneeRef', true, false, 'Shipment Consignee Ref'),
            //     new ValidatedField('shipmentShipperRef', true, false, 'Shipment Shipper Ref'),
            //     new ValidatedField('shipmentCarrier', true, false, 'Shipment Carrier'),
            //     new ValidatedField('shipmentServiceType', true, false, 'Shipment Service Type'),
            //     new ValidatedField('shipmentBillingParty', true, false, 'Shipment Billing Party'),
            //     new ValidatedField('shipmentBillingPartyDetail', false, false, 'Shipment Billing Party Detail'),
            //     new ValidatedField('shipmentDescription', true, false, 'Shipment Description'),
            //     new ValidatedField('shipmentPickupDate', true, false, 'Shipment Pickup Date'),
            //     new ValidatedField('shipmentDeliveryDate', true, false, 'Shipment Delivery Date'),
            //     new ValidatedField('shipmentDeliveryTime', true, false, 'Shipment Delivery Time'),
            //     new ValidatedField('shipmentCurrency', true, false, 'Shipment Currency'),
            //     new ValidatedField('shipmentValue', true, false, 'Shipment Value'),
            //     new ValidatedField('shipmentComments', true, false, 'Shipment Comments'),
            //     new ValidatedField('pieces', true, false, 'Dims Pieces'),
            //     new ValidatedField('length', false, false, 'Dims Length'),
            //     new ValidatedField('width', false, false, 'Dims Width'),
            //     new ValidatedField('height', false, false, 'Dims Height'),
            //     new ValidatedField('weight', false, false, 'Dims Weight'),
            //     new ValidatedField('packaging', false, false, 'Dims Packaging'),
            //     new ValidatedField('totalPieces', true, false, 'Dims Total Pieces'),
            //     new ValidatedField('totalWeight', true, false, 'Dims Total Weight'),
        ]
    }


}
